import { render, staticRenderFns } from "./ExternalQuiz.vue?vue&type=template&id=6dc5c050&scoped=true"
import script from "./ExternalQuiz.vue?vue&type=script&lang=js"
export * from "./ExternalQuiz.vue?vue&type=script&lang=js"
import style0 from "./ExternalQuiz.vue?vue&type=style&index=0&id=6dc5c050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5c050",
  null
  
)

export default component.exports